module.exports = __webpack_public_path__ + "img/defaultavatar.ec4d1980.png";